import {curlQuickStart, curlEndpoints} from './curl';
import {pythonQuickStart, pythonEndpoints} from './py';
import {javascriptQuickStart, javascriptEndpoints} from './js';
import {javaQuickStart, javaEndpoints} from './java';
import {swiftQuickStart, swiftEndpoints} from './swift';
import {objectivecQuickStart, objectivecEndpoints} from './obj_c';

export const QUICK_START_CODE = {};
export const ENDPOINTS_CODE = {};

// create keys for ENDPOINTS_CODE
const endpointsEntries = Object.entries({
    curl: curlEndpoints,
    java: javaEndpoints,
    javascript: javascriptEndpoints,
    python: pythonEndpoints,
    swift: swiftEndpoints,
    objectivec: objectivecEndpoints,
});

endpointsEntries.forEach( ([lang, code]) => {
    for (const step of Object.keys(code)) {
        ENDPOINTS_CODE[step] = {};
    }
});

// populate ENDPOINTS_CODE with code samples
endpointsEntries.forEach( ([lang, code]) => {
    for (const endpoint of Object.keys(code)) {
        ENDPOINTS_CODE[endpoint][lang] = code[endpoint];
    }
});


// create keys for QUICK_START_CODE
const quickStartEntries = Object.entries({
    curl: curlQuickStart,
    java: javaQuickStart,
    javascript: javascriptQuickStart,
    python: pythonQuickStart,
    swift: swiftQuickStart,
    objectivec: objectivecQuickStart,
});
quickStartEntries.forEach( ([lang, code]) => {
    for (const step of Object.keys(code)) {
        QUICK_START_CODE[step] = {};
    }
});

// populate QUICK_START_CODE with code samples
quickStartEntries.forEach( ([lang, code]) => {
    for (const step of Object.keys(code)) {
        QUICK_START_CODE[step][lang] = code[step];
    }
});
